import { render, staticRenderFns } from "./orderRatings.vue?vue&type=template&id=0e36fc6f"
import script from "./orderRatings.vue?vue&type=script&lang=js"
export * from "./orderRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports